export const FOCUS_AREAS = [
  "Criminal Justice Reform",
  "Climate & Environment",
  "Economic & Community Development",
  "Education & Youth",
  "Health & Wellness",
] as const;

export type FocusArea = (typeof FOCUS_AREAS)[number];

// Keywords used to match free-text fields (legislation.area, idea.category, article.category/tags)
// to a canonical focus area.
export const FOCUS_KEYWORDS: Record<FocusArea, string[]> = {
  "Criminal Justice Reform": ["justice", "police", "sentencing", "reentry", "incarcer", "prison"],
  "Climate & Environment": ["climate", "environment", "energy", "sustainab", "pollution", "green"],
  "Economic & Community Development": [
    "housing", "affordable", "economic", "mobility", "workforce", "small business",
    "entrepreneur", "minority-owned", "dbe", "cdfi", "wealth", "community development",
    "neighborhood", "main street", "place-based",
  ],
  "Education & Youth": ["education", "school", "youth", "student", "early childhood"],
  "Health & Wellness": ["health", "wellness", "medical", "mental", "maternal", "care"],
};

export function matchFocusAreas(text: string | null | undefined): FocusArea[] {
  if (!text) return [];
  const lower = text.toLowerCase();
  return (Object.keys(FOCUS_KEYWORDS) as FocusArea[]).filter((fa) =>
    FOCUS_KEYWORDS[fa].some((kw) => lower.includes(kw)),
  );
}